export default {
    meta: {
        title: '拓店宝-添加场地'
    }
};
